import $ from 'jquery';

function labelActive(el) {
  let inputId = el.attr('id');
  $(`label[for=${inputId}]`).addClass('active');
}

function labelInActive(el) {
  let inputId = el.attr('id');

  if (el.attr('type') === 'file') {
    const hasFile = el[0].files && el[0].files.length > 0;

    if (!hasFile) {
      $(`label[for=${inputId}]`).removeClass('active');
    }
    return;
  }

  if (!el.val()) {
    $(`label[for=${inputId}]`).removeClass('active');
  }

  if (el.val() === '(___) ___-____') {
    $(`label[for=${inputId}]`).removeClass('active');
  }
}

function labelFileToggle(el) {
  let inputId = el.attr('id');
  let hasFile = el[0].files && el[0].files.length > 0;

  if (hasFile) {
    labelActive(el);
  } else {
    $(`label[for=${inputId}]`).removeClass('active');
  }
}

function checkValueAndToggleLabel(el) {
  let type = el.attr('type');

  if (type === 'file') {
    labelFileToggle(el);
    return;
  }

  if (el.val() && el.val() !== '(___) ___-____') {
    labelActive(el);
  } else {
    labelInActive(el);
  }
}

function initLabelState() {
  $('.sk-form')
    .find('input, textarea')
    .each(function() {
      checkValueAndToggleLabel($(this));
    });
}

function initLabel() {
  if ($('.sk-form').length > 0) {
    initLabelState();

    $(document).on('focus', 'input', function() {
      labelActive($(this));
    });

    $(document).on('focusout', 'input', function() {
      labelInActive($(this));
    });

    $(document).on('focus', 'textarea', function() {
      labelActive($(this));
    });

    $(document).on('focusout', 'textarea', function() {
      labelInActive($(this));
    });

    $(document).on('change', 'input[type="file"]', function() {
      labelFileToggle($(this));
    });
  }
}

export {
  initLabel,
};